import axios from "../../utils/axios";
import type { AccountDTO } from "../types/miscServiceDtos";

const apiUrl = process.env.REACT_APP_MYWORKNEST_API_URL;

const searchAccountsByName = (accountName) =>
    axios.get<AccountDTO[]>(
      `${apiUrl}/account/search?accountName=${accountName}&safetyNestOnly=true`
    );

const accountService = {
    searchAccountsByName,
};

export default accountService;